export default __webpack_public_path__ + "static/media/canvasBgDesktop.5033fbd1.png";